
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

    container: () => {
        console.log('loading.useStyles.container() -> ', theme);
        return  {
            display: 'flex',
            height: '100vh',
            width: '100%',
          
            flexDirection: 'column !important',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            overflow: 'scroll',
        };
    },
    
    text: {
        color: '#FFFFFF',
        fontWeight: '400',
        fontSize: '20px',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
